"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Visibility = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Visibility = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "visibility", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "visibility", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M4 16c1.043-5.689 6.02-10 12-10s10.956 4.311 12 10c-1.043 5.689-6.02 10-12 10S5.044 21.689 4 16Zm12 5.556c1.47 0 2.881-.586 3.922-1.628a5.56 5.56 0 0 0 0-7.856 5.541 5.541 0 0 0-7.844 0 5.56 5.56 0 0 0 0 7.856A5.541 5.541 0 0 0 16 21.556Zm0-2.223a3.325 3.325 0 0 1-2.353-.976A3.336 3.336 0 0 1 16 12.667c.883 0 1.729.35 2.353.976A3.336 3.336 0 0 1 16 19.333Z", fill: "#172344" }) })) })));
};
exports.Visibility = Visibility;
